export const dialogSizes = {
  xsmall: 'min(90vw, 400px)',
  small: 'min(90vw, 500px)',
  medium: 'min(90vw, 700px)',
  large: 'min(90vw, 1100px)',
  xlarge: 'min(90vw, 1400px)',
  xxlarge: 'min(90vw, 1800px)',
} as const

export type DialogSize = keyof typeof dialogSizes
